import { render, staticRenderFns } from "./ConcursosPublicosView.vue?vue&type=template&id=78d980b3&scoped=true&"
import script from "./ConcursosPublicosView.vue?vue&type=script&lang=ts&"
export * from "./ConcursosPublicosView.vue?vue&type=script&lang=ts&"
import style0 from "./ConcursosPublicosView.vue?vue&type=style&index=0&id=78d980b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d980b3",
  null
  
)

export default component.exports